import {
    onlineCashAcquiringSlide,
    paymentQRBusiness,
    transferB2B,
    webTspBanner,
    onlineCashboxFreeBannerPages,
    ResortAcquiringPage,
    newsClientAcquiringBannerPages,
} from '@/core/models/common/MainSliderSlides/Buisness/BuisnessSlidesModel';
import {
    onlineCreditSlide,
    bankGuaranteesSlide,
    salaryProjectsSlide,
    checkoutSlide,
    creditHolidaysSlide,
    selfemloyedBusinessSlide,
    greenMortgageBusinessSlide,
} from '@/core/models/common/OfferSliderSlides/BusinessSlidesModel';
import {
    clientBankServiceSlide,
    acceleratorServiceSlide,
} from '@/core/models/common/OfferSliderSlides/OtherSlidesModel';
import {offerSlidesData} from '@/core/models/pages/business-page/rko/RKOModel';

const tabsData = [
    {
        label: 'популярные',
        slotName: 'popular',
    },
    {
        label: 'онлайн-касса',
        slotName: 'checkout',
    },
    {
        label: 'Кредитные каникулы',
        slotName: 'creditHolidays',
    },
];

const slidesData = [
    newsClientAcquiringBannerPages,
    transferB2B,
    onlineCashboxFreeBannerPages,
    ResortAcquiringPage,
    webTspBanner,
    paymentQRBusiness,
    onlineCashAcquiringSlide,
];

const popular = [
    bankGuaranteesSlide,
    salaryProjectsSlide,
    ...offerSlidesData,
];

const credit = [
    onlineCreditSlide,
    greenMortgageBusinessSlide,
    selfemloyedBusinessSlide,
];

const checkout = [checkoutSlide];

const creditHolidays = [creditHolidaysSlide];

const servicesData = [
    clientBankServiceSlide,
    acceleratorServiceSlide,
];

export {
    tabsData,
    slidesData,
    popular,
    credit,
    checkout,
    servicesData,
    creditHolidays,
};
